import { useState, useMemo } from 'react';

// Lightweight sort hook for MUI TableSortLabel-driven tables.
// `accessors` maps column key -> (row) => comparable value. Default order is asc.
export default function useSortableTable(rows, accessors, initial = { key: null, dir: 'asc' }) {
  const [order, setOrder] = useState(initial);

  const handleSort = (key) => {
    setOrder((prev) => prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' });
  };

  const sorted = useMemo(() => {
    if (!order.key || !accessors[order.key]) return rows;
    const get = accessors[order.key];
    const arr = [...rows];
    arr.sort((a, b) => {
      const va = get(a);
      const vb = get(b);
      if (va === vb) return 0;
      if (va === undefined || va === null) return 1;
      if (vb === undefined || vb === null) return -1;
      if (typeof va === 'number' && typeof vb === 'number') return order.dir === 'asc' ? va - vb : vb - va;
      const cmp = String(va).localeCompare(String(vb));
      return order.dir === 'asc' ? cmp : -cmp;
    });
    return arr;
  }, [rows, order, accessors]);

  return { sorted, order, handleSort };
}
